import { gql } from '@apollo/client'
import { Copropriete } from '../fragment/copropriete.fragment'

export const COPROPRIETE_ALL = gql`
  query CoproprietesAll {
    managed: coproprietes(select: "managed") {
      id
      nom
      trigramme
      identifiantics
      ...Etat
    }
    notManaged: coproprietes(select: "not_managed") {
      id
      nom
      trigramme
      identifiantics
      ...Gestionnaire
    }
  }
  ${Copropriete.fragments.etat}
  ${Copropriete.fragments.gestionnaire}
`

export const COPROPRIETE_DETAIL = gql`
  query CoproprieteDetail($id: bigint!) {
    copropriete: d4_copropriete(where: { id: { _eq: $id } }) {
      id
      trigramme
      batiments(order_by: { libelle: asc }) {
        id
        libelle
        equipements(order_by: { libelle: asc }) {
          id
          libelle
        }
      }
    }
  }
`

export const COPROPRIETE_GN_GS = gql`
  query CoproprieteDetail($id: bigint!) {
    copropriete: d4_copropriete_by_pk(id: $id) {
      id
      trigramme
      gestionnaire {
        id
        mail1
      }
      gestionnaireSedentaire {
        id
        mail1
      }
    }
  }
`

export const PERSONNE_LOT_COPROPRIETE = gql`
  query PersonneLotCopropriete($search: String!) {
    personnes: d4_lot(
      distinct_on: copropriete_id
      order_by: { copropriete_id: asc }
      where: { lot_coproprietaire: { coproprietaire: { personne: { nom: { _ilike: $search } } } } }
    ) {
      lot_coproprietaire {
        coproprietaire {
          personne {
            id
            nom
            prenom
          }
        }
      }
      copropriete_id
      copropriete {
        id
        trigramme
      }
    }
    coproprietes: d4_copropriete(where: { trigramme: { _ilike: $search }, _and: { statutcopropriete: { _eq: 0 } } }) {
      id
      trigramme
      nom
    }
  }
`

export const COPROPRIETE_SEARCH = gql`
  query CoproprieteSearch($search: String!) {
    coproprietes: d4_copropriete(where: { trigramme: { _ilike: $search }, _and: { statutcopropriete: { _eq: 0 } } }) {
      id
      trigramme
      nom
    }
  }
`
